import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const Message = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size}>
    <path
      d="M22 2H2V18H7V22L11 18H22V2ZM20 16H13H7H4V4H20V16Z"
      fill="currentColor"
    />
    <path d="M17 7H7V9H17V7Z" fill="currentColor" />
    <path d="M15.2 11H7V13H15.2V11Z" fill="currentColor" />
  </SvgIcon>
);

export default Message;
